export default {
    lendingLimitLoanSummaryModal: {
        isOpen: false,
        loans: [],
    },
};
